import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { getUserInfo, updateDescription } from "../../services/account-setting.services";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";

export default function EditBusinessDescription() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      description: "",
    },
  });

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await getUserInfo();

        if (response?.success && response?.data) {
          const userData = response.data;
          setValue("description", userData.description || "");
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: "Failed to load business information",
          ...SWAL_SETTINGS,
        });
      }
    };
    fetchUserInfo();
  }, [setValue]);

  const onSubmit = async (data) => {
    try {
      const response = await updateDescription({ description: data.description });

      if (response?.success) {
        Swal.fire({
          icon: "success",
          text: "Description updated successfully!",
          ...SWAL_SETTINGS,
        });

        navigate("/business/account-setting/edit-business-description");
      } else {
        Swal.fire({
          icon: "error",
          text: response?.message || "Failed to update description",
          ...SWAL_SETTINGS,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Something went wrong while updating description.",
        ...SWAL_SETTINGS,
      });
    }
  };

  return (
    <div  className="main-content">
    <div className="customer-part">
      <div className="card-box">
    <div className="container form-wrapper section-section" style={{ boxShadow: "none" }}>
      <h4 className="h3-headline mb-5 text-center">Business Description</h4>

      <form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: "2rem" }}>
        <div className="form-group">
          <label className="form-label subtitle-1" htmlFor="description">
            Business Description
          </label>
          <textarea
                  id="description"    
                  {...register("description", {
                    required: "Description is required",
                    minLength: { value: 20, message: "Minimum 20 characters" },
                    maxLength: { value: 350, message: "Maximum 350 characters" },
                    pattern: {
                      value: /^[a-zA-Z0-9\s.,'":;!?()-]+$/,
                      message: "Only letters, numbers, and common punctuation are allowed",
                    },
                    setValueAs: (value) => value.trim(), // ✅ Trim before validation
                    validate: (value) => value.trim().length > 0 || "Description cannot be only spaces", // ✅ No only-spaces input
                  })}
                  className="form-control mw-100"
                  rows={5}
                  placeholder="Enter the name of your business."
                />
          {errors.description && <p className="text-danger mt-1">{errors.description.message}</p>}
        </div>

        <div className="text-center mt-5">
          <button type="submit" className="btn btn-oring">
            Update
          </button>
        </div>
      </form>
    </div>
    </div>
    </div>
    </div>
  );
}
